import styled, { css } from 'styled-components';

import { baseColors, colorScheme } from '../../theme';

interface textProps {
  variant?: 'primary' | 'secondary' | 'warning' | 'danger' | 'alert' | 'good' | 'tertiary';
  clickable?: boolean;
}

const basicStyle = css`
  display: inline-block;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  padding: 4px 8px;
`;

const variantStyles = (variant = 'primary') =>
  ({
    primary: css`
      ${basicStyle}
      background: ${colorScheme.brand};
      color: #fff;
      font-size: 11px;
      font-weight: 600;
      padding: 2px 8px;
    `,
    secondary: css`
      ${basicStyle}
      background: ${colorScheme.badge.background};
      color: ${colorScheme.buttons.secondary.text};
    `,
    tertiary: css`
      ${basicStyle}
      background: ${colorScheme.buttons.ternary.background};
      color: ${colorScheme.text.base};
    `,
    warning: css`
      ${basicStyle}
      background: ${baseColors.orange};
      color: #000;
    `,
    danger: css`
      ${basicStyle}
      background: ${baseColors.red};
      color: #000;
    `,
    alert: css`
      ${basicStyle}
      background: ${baseColors.orange};
      color: ${colorScheme.panelBackground};
    `,
    good: css`
      ${basicStyle}
      background: ${baseColors.green};
      color: ${colorScheme.panelBackground};
    `,
  })[variant];

export const Badge = styled.span<textProps>`
  ${({ variant }) => variantStyles(variant)}

  white-space: nowrap;
  display: inline-flex;
  flex-shrink: 0;

  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}
`;
